/**
 * Index spot instrument tokens.
 *
 * Hardcoded, and that is a known shortcut with a known expiry date: these come
 * from the catalogue (`InstrumentIndex.indexTokenOf` in the engine) and a
 * broker renumbering an index would silently leave the strip and the ATM
 * calculation reading a token that no longer exists.
 *
 * Two components need them — the spot strip and the chain's ATM scroll — which
 * is why they live here rather than in either one. ROADMAP 3.16 replaces this
 * with the value the chain endpoint already knows.
 */
export const SPOT_TOKENS: Record<string, number> = {
  NIFTY: 26_000,
  BANKNIFTY: 26_001,
  // Verified against the catalogue 2026-10-08: these two were missing, so
  // their tiles read "No instrument" while the index is listed and quoted.
  FINNIFTY: 26_034,
  SENSEX: 26_065,
  BANKEX: 26_118,
}

/*
 * India VIX is deliberately absent: it is NOT in the instrument catalogue
 * at all — the only segment-1/11 index rows are the five above plus NIFTY
 * NEXT 50, NIFTY MID SELECT, SNSX50 and FOCIT. Adding a guessed token would
 * subscribe nothing and render a dash that looks like a feed fault.
 */
